import {
  UpdateDTO,
  useUpdateMutationFactory,
  UseUpdateMutationProps,
} from '@/lib/react-query/update';
import { Inspection, InspectionLog } from '@/types';
import { update } from '@/utils/api';
import { featureKeys, featurePath, InspectionLogSearchParams } from '.';

export type UpdateInspectionLogDTO = {
  inspection: Inspection;
} & UpdateDTO<InspectionLog, InspectionLogSearchParams>;

const updateInspectionLog = ({ inspection, data, id, params = {} }: UpdateInspectionLogDTO) =>
  update<InspectionLog>(`${featurePath(inspection)}/${id}`, data, params);

export const useUpdateInspectionLog = (options?: UseUpdateMutationProps<InspectionLog>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: updateInspectionLog,
    ...options,
  });
};
